import { Injectable, OnDestroy } from '@angular/core';
import confetti from 'canvas-confetti';
import { PathwayLocalStorageUtil } from 'src/app/utils/pathway-localstorage.util';

// How long to wait before resetting the canvas after the burst (ms)
const CONFETTI_RESET_DELAY_MS = 15000;

const CONFETTI_COLORS = [
  '#6CB2BC', // $brand-400
  '#87C0C8', // $brand-300
  '#B0EBC8', // $green-10
  '#6EDEA1', // $green-6 / $success-1000
];

@Injectable({
  providedIn: 'root',
})
export class ConfettiService implements OnDestroy {
  private resetTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnDestroy(): void {
    this.stop();
  }

  launchForEnrollment(enrollmentUuid: string | null): void {
    if (!enrollmentUuid) return;
    if (PathwayLocalStorageUtil.hasConfettiBeenShown(enrollmentUuid)) return;

    PathwayLocalStorageUtil.markConfettiAsShown(enrollmentUuid);
    this.celebrate();
  }

  stop(): void {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
      this.resetTimer = null;
    }
    confetti.reset();
  }

  private celebrate(): void {
    const count = 1500;
    const defaults = {
      origin: { y: 0.5 },
      colors: CONFETTI_COLORS,
      shapes: ['square' as const],
      gravity: 0.8,  // lower = slower fall (default is 1)
      ticks: 800,    // higher = particles stay on screen longer (default is 200)
    };

    const sizes = [0.5, 1];
    const randomScalar = (): number => sizes[Math.floor(Math.random() * sizes.length)];

    const fire = (particleRatio: number, opts: confetti.Options): void => {
      const scalar = opts.scalar ?? randomScalar();
      confetti({ ...defaults, ...opts, scalar, particleCount: Math.floor(count * particleRatio) });
    };

    fire(0.25, { spread: 26, startVelocity: 30 });
    fire(0.20, { spread: 60, startVelocity: 25 });
    fire(0.35, { spread: 100, decay: 0.94, scalar: 0.8 });
    fire(0.10, { spread: 120, startVelocity: 15, decay: 0.95, scalar: 1.2 });
    fire(0.10, { spread: 120, startVelocity: 28 });

    this.resetTimer = setTimeout(() => this.stop(), CONFETTI_RESET_DELAY_MS);

  }
}
